import * as ss from 'superstruct';

export const WebhookOutputStreamDestination = ss.type({
  name: ss.literal('webhook'),
  webhookUrl: ss.string(),
});

export type WebhookOutputStreamDestination = ss.Infer<
  typeof WebhookOutputStreamDestination
>;
